import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { updateShipmentConfiguration, startUpdateAvailableShippingServices } from '../../store/csw/csw.actions';

export const isAddressCompleteForRating = (address) => {
  if (!address) {
    return false;
  }

  const basicAddressCheck = address.line1 && address.city && address.postalCode && address.countryCode;

  if (['US', 'CA'].includes(address.countryCode)) {
    return basicAddressCheck && address.state;
  }

  return basicAddressCheck;
};

export const useShipToState = (fulfillmentPlanId, onConfigurationChange, shipFromId) => {
  const dispatch = useDispatch();

  const onShipToChange = useCallback(
    (shipTo) => {
      onConfigurationChange({ shipTo }, { shouldUpdateNeedsCustoms: true });
      dispatch(updateShipmentConfiguration(fulfillmentPlanId, { shipTo }));
      dispatch(startUpdateAvailableShippingServices(fulfillmentPlanId, shipFromId));
    },
    [dispatch, fulfillmentPlanId, shipFromId, onConfigurationChange],
  );

  const onShipToEmailChange = useCallback(
    (emailAddress) => {
      dispatch(updateShipmentConfiguration(fulfillmentPlanId, { email: emailAddress }));
      onConfigurationChange({ email: emailAddress });
    },
    [dispatch, fulfillmentPlanId, onConfigurationChange],
  );

  return {
    onShipToChange,
    onShipToEmailChange,
  };
};
